import {Component, inject, input} from '@angular/core';
import {NavItem} from './sidebar-nav-items.model';
import {SidebarNavService} from './sidebar-nav.service';
import {RouterModule} from '@angular/router';
import {Button} from 'primeng/button';
import {Tooltip} from 'primeng/tooltip';

@Component({
	selector: 'app-sidebar-nav',
	imports: [RouterModule, Button, Tooltip],
	standalone: true,
	host: { 'class': 'flex flex-column gap-3' },
	template: `
		@for (item of navItems; track item.label) {
			@if (item.route) {
				<p-button
					[routerLink]="item.route"
					[icon]="item.icon"
					[label]="expanded() ? item.label : ''"
					[pTooltip]="expanded() ? '' : item.label"
					[styleClass]="expanded() ? 'sidebar-nav__button sidebar-nav__button--expanded' : 'sidebar-nav__button'"
					[class.p-button-active]="item.isActive?.()"
					[variant]="item.isActive?.() ? 'outlined' : 'text'" />
			} @else {
				<p-button
					[icon]="item.icon"
					[label]="expanded() ? item.label : ''"
					[pTooltip]="expanded() ? '' : item.label"
					[styleClass]="expanded() ? 'sidebar-nav__button sidebar-nav__button--expanded' : 'sidebar-nav__button'"
					(onClick)="item.command?.()"
					[class.p-button-active]="item.isActive?.()"
					[variant]="item.isActive?.() ? 'outlined' : 'text'" />
			}
		}
	`,
	styleUrl: './sidebar-nav.css'
})
export class SidebarNav {
	private sidebarNavService: SidebarNavService = inject(SidebarNavService)

	expanded = input(false)
	navItems: NavItem[] = this.sidebarNavService.visibleMenuItems()
}
